var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12c0-1.952-.161-3.752-.352-5.196a2.811 2.811 0 0 0-2.452-2.452A40.092 40.092 0 0 0 12 4c-1.952 0-3.752.161-5.196.352a2.811 2.811 0 0 0-2.452 2.452A40.091 40.091 0 0 0 4 12c0 1.952.161 3.752.352 5.196a2.811 2.811 0 0 0 2.452 2.452C8.248 19.84 10.048 20 12 20c1.952 0 3.752-.161 5.196-.352a2.81 2.81 0 0 0 2.452-2.452C19.84 15.752 20 13.952 20 12Zm1.631-5.458a4.81 4.81 0 0 0-4.173-4.173C15.948 2.169 14.058 2 12 2c-2.059 0-3.948.17-5.458.369a4.81 4.81 0 0 0-4.173 4.173C2.169 8.052 2 9.942 2 12c0 2.059.17 3.948.369 5.458a4.81 4.81 0 0 0 4.173 4.173c1.51.2 3.4.369 5.458.369 2.059 0 3.948-.17 5.458-.369a4.81 4.81 0 0 0 4.173-4.173c.2-1.51.369-3.4.369-5.458 0-2.059-.17-3.948-.369-5.458Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.207 9.793a1 1 0 0 0-1.414 0L12 12.586 9.207 9.793a1 1 0 0 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414Z",
    fill: "#777E91"
  })));
};
export default SvgLine;